module.exports = __webpack_public_path__ + "static/media/orangeTarget.13878e64.svg";